import "./style.css";

export default class LayoutGrid {
  static selector = ".layout-grid";

  HOTKEY = "g";

  toggleGrid = (e) => {
    if (e.ctrlKey && e.key.toLowerCase() === this.HOTKEY) {
      this.block.classList.toggle("no-display");
    }
  };

  constructor(block) {
    this.block = block;
    document.addEventListener("keydown", this.toggleGrid);
  }
}
